import { Numeric } from './numeric';
import { Options } from '../column';

export class Id extends Numeric {

    public type = 'id-field';

    public reorderable = false;

    public width = 120;

    public locked = true;

    constructor(options: Options) {
        super(options);
        this.__construct(options);
    }

}



// WEBPACK FOOTER //
// ./libs/chassis-datatable/src/classes/columns/id.ts